import { IBillingInformation } from 'shared/interfaces/IAccount';

export const INITIAL_BILLING_INFORMATION: IBillingInformation = {
  business_information: {
    legal_business_name: '',
    type: '',
    address: '',
    zip_code: '',
    city: '',
    state: '',
    country: 'US',
    business_phone_no: '',
    company_tax_id: '',
    phone_country_code: 'us',
    primary: false,
  },
  business_representative: {
    first_name: '',
    last_name: '',
    address: '',
    zip_code: '',
    city: '',
    state: '',
    country: 'US',
    phone_country_code: 'us',
    phone_number: '',
    same_as_business: true,
  },
  personal_information: {
    first_name: '',
    last_name: '',
    address: '',
    zip_code: '',
    city: '',
    state: '',
    country: 'US',
    phone_country_code: 'us',
    phone_number: '',
    primary: true,
  },
};
